import { Component, OnInit } from '@angular/core';
import { LocalStorage, JSONSchema } from "@ngx-pwa/local-storage";
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { CONFIG } from 'src/app/dummy/app';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  appInfo="EVA"
  expansions = {
    one: true,
    two: false,
    three: false,
    four: false,
    five: false,
    six: false,
    seven: false,
    eight: false,
    nine: false,
    ten: false,
  };
  toggleSidebar: boolean = true;
  disabled: boolean = true;
  profile: any;
  APPS:any=CONFIG
  constructor(
    protected localStorages: LocalStorage,
    public ds: DataService,
    private router: Router,
    public auth:AuthStore
  ) {
  }

  ngOnInit() {
    this.localStorages.getItem("toggleSidebar").subscribe(toggleSidebar => {
      this.disabled = this.toggleSidebar;
      if (!this.toggleSidebar) {
        let body = document.getElementsByClassName("page-wrapper")[0];
        body.classList.toggle("toggled-sidebar");
      }
    });
    const schema: JSONSchema = {
      type: 'object',
      properties: {
        one: { type: "boolean" },
        two: { type: "boolean" },
        three: { type: "boolean" },
        four: { type: "boolean" },
        five: { type: "boolean" },
        six: { type: "boolean" },
        seven: { type: "boolean" },
        eight: { type: "boolean" },
        nine: { type: "boolean" },
        ten: { type: "boolean" },
      }
    };
    this.localStorages.getItem<any>("expansions", { schema }).subscribe(
      expansion => {
        if (expansion) this.expansions = expansion;
        else {
          this.localStorages
            .setItem("expansions", this.expansions)
            .subscribe(() => { }, error => { });
        }
      },
      error => { }
    );
  }

  onLogOut() {
    this.auth.signOut(data=>{
      this.router.navigate(['/login'])
    })
  }

  togglesidebar() {
    let body = document.getElementsByClassName("page-wrapper")[0];
    body.classList.toggle("toggled-sidebar");
    this.toggleSidebar = !this.toggleSidebar;
    this.localStorages
      .setItem("toggleSidebar", this.toggleSidebar)
      .subscribe(() => { });
  }

  onOpened(i) {
    const isopen = true;
    switch (i) {
      case 0:
        this.expansions.one = isopen;
        break;
      case 1:
        this.expansions.two = isopen;
        break;
      case 2:
        this.expansions.three = isopen;
        break;
      case 3:
        this.expansions.four = isopen;
        break;
      case 4:
        this.expansions.five = isopen;
        break;
      case 5:
        this.expansions.six = isopen;
        break;
      case 6:
        this.expansions.seven = isopen;
        break;
      case 7:
        this.expansions.eight = isopen;
        break;
      case 8:
        this.expansions.nine = isopen;
        break;
      case 9:
        this.expansions.ten = isopen;
        break;
      default:
        break;
    }
    this.localStorages
      .setItem("expansions", this.expansions)
      .subscribe(() => { }, error => { });
  }
  onClosed(i) {
    const isopen = false;
    switch (i) {
      case 0:
        this.expansions.one = isopen;
        break;
      case 1:
        this.expansions.two = isopen;
        break;
      case 2:
        this.expansions.three = isopen;
        break;
      case 3:
        this.expansions.four = isopen;
        break;
      case 4:
        this.expansions.five = isopen;
        break;
      case 5:
        this.expansions.six = isopen;
        break;
      case 6:
        this.expansions.seven = isopen;
        break;
      case 7:
        this.expansions.eight = isopen;
        break;
      case 8:
        this.expansions.nine = isopen;
        break;
      case 9:
        this.expansions.ten = isopen;
        break;
      default:
        break;
    }
    this.localStorages
      .setItem("expansions", this.expansions)
      .subscribe(() => { }, error => { });
  }

}
